import { render, staticRenderFns } from "./switchWidth-editor.vue?vue&type=template&id=48180283&scoped=true"
import script from "./switchWidth-editor.vue?vue&type=script&lang=js"
export * from "./switchWidth-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48180283",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48180283')) {
      api.createRecord('48180283', component.options)
    } else {
      api.reload('48180283', component.options)
    }
    module.hot.accept("./switchWidth-editor.vue?vue&type=template&id=48180283&scoped=true", function () {
      api.rerender('48180283', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/switchWidth-editor.vue"
export default component.exports